// utils/momentText.js — Anamoria SPA
// v0.1 — 3.2 detail paragraph split (July 21, 2026)
//
// Spec §2.7 (hearth-capture-detail-feed-specs): multi-paragraph written text
// renders as <p> elements --space-4 apart; plain text, no markdown.
// Blank-line split; single newlines stay inside a paragraph (they are typed
// line breaks, not paragraph intent — legacy parity: the app has never
// rendered note text with preserved single newlines).
// Per momentdetail-3-2-DRAFT-for-review-v0.3.md E-8.

export function splitParagraphs(note) {
  if (!note || typeof note !== 'string') return [];
  return note
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);
}
